module.exports = __webpack_public_path__ + "static/logo-06036ef3bb6dce7a8783bb834e2d3c17.svg";